module.exports = __webpack_public_path__ + "static/media/tickleNow@2x.0061540d.png";